import { eu } from './countries.js';

export const Global = {
  key: 'global',
  type: 'regional',
  country: { code: '' },
  name: '#NewMusic Global',
  short_name: 'Global',
  mountPoint: 'most_rated',
  live: true,
  icon: 'public'
};

const GB = {
  key: 'GB',
  type: 'regional',
  mountPoint: 'most_rated_GB',
  country: { code: 'GB' },
  name: '#NewMusic UK',
  short_name: 'UK',
  long_name: 'United Kingdom',
  slug: 'british',
  trackMatch: { channels: { $regex: `^GB` } },
  live: true
};

const north_american = {
  key: 'north_american',
  type: 'regional',
  mountPoint: 'most_rated_north_american',
  name: '#NewMusic USA & Canada',
  country: { code: 'USCA' },
  short_name: 'USA & Canada',
  slug: 'north-american',
  trackMatch: { channels: { $in: ['US', 'CA'] } },
  live: true
};

const US = {
  key: 'US',
  type: 'regional',
  mountPoint: 'most_rated_US',
  country: { code: 'US' },
  name: '#NewMusic USA',
  slug: 'american',
  trackMatch: { channels: { $eq: 'US' } },
  live: false
};

const EU = {
  key: 'EU',
  type: 'regional',
  mountPoint: 'most_rated_EU',
  country: { code: 'EU' },
  name: '#NewMusic Europe',
  short_name: 'Europe',
  slug: 'european',
  trackMatch: { channels: { $in: eu } },
  live: true
};

const EDM = {
  key: 'EDM',
  type: 'genre',
  mountPoint: 'most_rated_EDM',
  name: 'Electro & Dance',
  short_name: 'EDM',
  slug: 'edm',
  trackMatch: {
    channels: { $in: ['EDM'] }
  },
  live: true,
  icon: 'synth'
};

const Pop = {
  key: 'Pop',
  type: 'genre',
  icon: 'mic_external_on',
  mountPoint: 'most_rated_Pop',
  name: 'Indie / Alternative & Pop',
  short_name: 'Pop',
  trackMatch: {
    channels: { $in: ['Pop'] }
  },
  live: true,
  slug: 'pop'
};

const Rock = {
  key: 'Rock',
  mountPoint: 'most_rated_Rock',
  name: 'Rock',
  short_name: 'Rock',
  trackMatch: {
    channels: { $in: ['Rock'] }
  },
  live: true,
  slug: 'rock',
  type: 'genre',
  icon: 'flying_v'
};

const Chill = {
  key: 'Chill',
  name: 'Chill',
  short_name: 'Chill',
  trackMatch: {
    channels: { $in: ['Chill'] }
  },
  live: false,
  slug: 'chill',
  type: 'genre'
};

const Mobo = {
  key: 'Mobo',
  name: 'Mobo',
  short_name: 'Mobo',
  trackMatch: {
    channels: { $in: ['Mobo'] }
  },
  live: false,
  slug: 'mobo',
  type: 'genre'
};

const Folk = {
  key: 'Folk',
  name: 'County & Folk',
  short_name: 'Folk',
  mountPoint: 'most_rated_Folk',
  trackMatch: {
    channels: { $in: ['Folk'] }
  },
  live: true,
  slug: 'country_folk',
  type: 'genre',
  icon: 'guitar'
};

export const channels = [Global, GB, north_american, US, EU, EDM, Pop, Rock, Folk, Chill, Mobo];

export const vibeChannelMapping = {
  dancy: EDM,
  poppy: Pop,
  rocky: Rock,
  chill: Chill,
  mobo: Mobo,
  folky: Folk
};

export const liveChannels = channels
  .filter((channel) => channel.live)
  .map((channel) =>
    Object.keys(channel)
      .filter((key) => !['trackMatch'].includes(key))
      .reduce((obj, key) => {
        obj[key] = channel[key];
        return obj;
      }, {})
  );
